<template>
    <div class="my-4 ma-md-5 mx-lg-12">
    <v-row
      no-gutters
      v-bind:class="[
        'mx-2 align-center',
        {
          'flex-column justify-center': !$vuetify.breakpoint.mdAndUp,
        },
      ]"
    >
    </v-row>
    <template>
      <v-row class="titleMobile"
      :style="{gap: '1rem', marginLeft: '1rem !important'}">
        <v-btn
          class="back"
          dark
          icon
          to="/utils"
        >
          <v-icon
          :style="{color: '#27846d !important', fontSize: '34px'}"
          >
            icon-ayudadigital-volver
          </v-icon>
        </v-btn>
        <h2> {{ $t('views.utils.conversor.title') }} </h2>
      </v-row>
      <v-container class="mt-3 converter-container" fluid>
        <v-row>
          <p> {{ $t('views.utils.conversor.description') }} </p>
        </v-row>
        <v-row justify="center">
          <v-col cols="12" sm="6" md="6" class="text-center textMobile">
            <v-textarea
              v-model="inputTlfno"
              label="Introduce el número..."
              placeholder="Introduce el número..."
              rows="1"
              outlined
              auto-grow
              hide-details
            />
          </v-col>
          <v-col cols="12" sm="6" md="6" class="text-center btnMobile">
            <v-btn
              class="converter-btn"
              color="primary"
              block
              @click="()=> converterTlfno()"
            >
              Convertir
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="tlfnoConverted != ''" justify="center">
          <v-col cols="12" sm="6" md="6" class="text-center textMobile">
            <v-textarea
                v-model="tlfnoConverted"
                class="mb-2 !important"
                label="Número convertido"
                auto-grow
                outlined
                rows="1"
                readonly
                hide-details
            />
          </v-col>
          <v-col cols="12" sm="6" md="6" class="text-center btnMobile">
            <div class="ki-actions btnGroupShare col-auto px-0 pt-0 pb-0"
              :style="{ borderColor: 'rgb(39, 132, 109)'  }">
              <v-btn
                class="v-btn v-btn--icon v-btn--round
                theme--light v-size--default iconHover"
                color="primary--text blue-grey lighten-4 donwload"
                dark
                icon
                @click.prevent="$event => share($event)"
              >
                <v-icon
                  :style="{color:'#757575'}"
                >
                  mdi-share-variant
                </v-icon>
              </v-btn>
              <v-spacer class="spacer"></v-spacer>
              <v-btn
                class="v-btn v-btn--icon v-btn--round
                theme--light v-size--default iconHover"
                color="primary--text blue-grey lighten-4"
                dark
                icon
                @click="copyTlfnoConverted"
                >
                <v-icon
                  :style="{color:'#757575'}"
                >
                  mdi-content-copy
                </v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <v-row v-if="showBtnRetry">
          <v-col cols="12" sm="6" md="6"  class="text-center btnClear">
            <v-btn
              @click="clear"
              plain
            >
              <v-icon left>mdi-refresh</v-icon>
              Convertir otro teléfono
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </template>
    <ShareDialog
      :visible="openDialog"
      @input="openDialog = false"
      :item="sharedItem || {}"
      :positionX="sharedDialogPosition.positionX"
      :positionY="sharedDialogPosition.positionY"
    ></ShareDialog>
  </div>
</template>

<script>

import { ShareDialog } from '@/components';

export default {
  components: { ShareDialog },
  data() {
    return {
      inputTlfno: '',
      tlfnoConverted: '',
      loading: false,
      openDialog: false,
      sharedItem: null,
      sharedDialogPosition: {},
      showBtnRetry: false,
    };
  },
  methods: {
    async converterTlfno() {
      const { id, userid } = this.$store.getters['session/user'];
      const inputTlfnoAux = this.inputTlfno.trim().replace(/\s+/g, '');

      const data = {
        apiCges: {
          delegado: userid,
          uuidSuscriptor: id,
        },
        telefono: inputTlfnoAux,
      };

      const result = await this.$api.getClient('utils').converterTfno(data);
      this.showBtnRetry = true;
      console.log('result', result);
      this.tlfnoConverted = result.data;
    },
    clear() {
      this.inputTlfno = '';
      this.tlfnoConverted = '';
      this.showBtnRetry = false;
    },
    async copyTlfnoConverted() {
      if (this.tlfnoConverted) {
        await navigator.clipboard.writeText(this.tlfnoConverted);

        this.$store.dispatch('messages/createNotificationMessage', {
          type: 'success',
          icon: 'mdi-check-circle',
          title: this.$t('views.utils.conversor.tlfCopiado'),
          timeout: this.$getConst('notifications.timeout'),
        });
      }
    },
    share(evt) {
      console.log('evt', evt);
      evt.preventDefault();
      const isMobile = this.$store.getters['globalState/get']('deviceOS') != null;
      if (isMobile === true && window.flutter_inappwebview) {
        const args = {
          url: `${window.location.origin}${this.$router.options.base}element/${this.ticketTypeData.toLowerCase()}/${this.elementIdData}`,
          tlfno: this.tlfnoConverted,
        };
        window.flutter_inappwebview.callHandler('shareDataUsingNative', args);
      } else {
        const fullShareUrl = `${process.env.VUE_APP_EXTERNAL_URL}${process.env.VUE_APP_BASE_URL_MICS_SSPA}utils/converter`;
        this.openDialog = true;
        this.sharedItem = {
          url: fullShareUrl,
          tlfno: this.tlfnoConverted,
        };

        const closestButton = evt.target.closest('button');
        const boundingRect = closestButton.getBoundingClientRect();

        this.sharedDialogPosition = {
          positionX: boundingRect.left + (closestButton.offsetWidth / 2),
          positionY: boundingRect.top + (closestButton.offsetHeight / 2),
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.converter-container {
  width: 100%;
  background: #fff;
  padding: 2rem !important;
  min-width: 100% !important;
}
.converter-btn {
  color: #fff !important;
  font-weight: 600;
  box-shadow: none;
  margin-top: 16px !important;
}
.converter-btn .v-icon {
  color: #fff !important;
}
.v-btn--block{
    min-width: 135px !important;
    max-width: 135px !important;
}
.v-icon{
  margin: 0 !important;
}
.btnGroupShare{
  display: flex;
  padding-top: 12px !important
}
.spacer{
  width: 1rem !important;
  max-width: 1rem !important;
}
.ki-actions {
  position: relative;
  /*padding-top: 18px !important;*/

  > button {
    width: 42px !important;
    height: 42px !important;
    border-radius: 50%;
    border-color: inherit;
    border-width: 2px;
    border-style: solid;
    background-color: white;

    &:last-child .ki-action-name.right {
      left: 100%;
      display: table;
      transform: translateX(-100%);
    }
  }

  .ki-action-name {
    pointer-events: none;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
}
@media screen and (max-width: 600px) {
    .v-btn--block{
        margin-top: 0px !important;
        min-width: 100% !important;
        max-width: 100% !important;
    }
    .textMobile{
      padding-bottom: 0px !important;
    }
    .btnClear{
      padding-top: 0px !important;
    }
    .btnGroupShare{
      justify-content: center;
    }
}
</style>
